/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { Form, Formik } from 'formik';
import { TextArea2 } from 'components/Dialog';
import Icon from 'components/Icon';
import Checkbox from "@fitinsur/components/Form/CheckBox";
import { Label } from "@fitinsur/components/Form";
import { debounce } from "lodash";


import {
  Dialog,
  DialogBody,
  DialogCancel,
  DialogConfirm,
  ContentTextArea,
  CardHeader,
  IconsContainer,
  IconAddContainer,
  IconRequired,
} from './styles';

export default function NotesModalV2({ onSubmit, show, handleClose, notesHistory, isRequireAttentionHistory, label, notesModalProps, handleGetNotes, updateData, handleSubmitNotes }) {
  const [visible, setVisible] = useState(show);

  const [isEditing, setIsEditing] = useState(false);
  const [notesHistoryChanged, setNotesHistoryChanged] = useState('');
  const [value, setValue] = useState("");
  const [isRequireAttention, setIsRequireAttention] = useState(false);

  const myRef = useRef();

  useEffect(() => {
    setNotesHistoryChanged(notesHistory);
  }, [notesHistory, notesModalProps]);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => {
    if (isRequireAttentionHistory === true || isRequireAttentionHistory === false) {
      setIsRequireAttention(isRequireAttentionHistory);
    } else {
      setIsRequireAttention(false);
    }
  }, [isRequireAttentionHistory])


  const handleSubmit = () => {
    onSubmit(value, isRequireAttention);
    setIsEditing(false);
    setValue('');
  }

  const handleRequireAttention = (value) => {
    handleSubmitNotes(notesModalProps?.item, null, value)
    updateData(notesModalProps?.item, value);
  }

  return (
    <Dialog canShow={visible} >
      <DialogBody ref={myRef}>
        <CardHeader >
          <div>
            {label}
          </div>
          <IconsContainer>
            <Icon
              name="Close"
              className="icon-close"
              onClick={() => {
                handleClose();
                setIsEditing(false)
                setNotesHistoryChanged('')
                setValue('')
                setIsRequireAttention(isRequireAttentionHistory)
              }}
            />
          </IconsContainer>
        </CardHeader>
        <IconAddContainer>
          <Icon
            name="add"
            className="icon-add-black"
            onClick={() => {
              setIsEditing(true)
            }}
          />
          <IconRequired>

            {!isEditing && (
                <Label style={{display:'flex'}}>
                  <div style={{display:'flex'}}>

                  <Checkbox
                    type="checkbox"
                    checked={isRequireAttention}
                    onChange={(e) => {
                      setIsRequireAttention(e.target.checked)
                      handleRequireAttention(e.target.checked)
                    }}
                    />
                  <span>Require Attention</span>
                    </div>
                </Label>
            )}
          </IconRequired>
        </IconAddContainer>
        <Formik
          initialValues={{
            notes: ''
          }}
          onSubmit={() => handleSubmit()}>
          <Form>
            <ContentTextArea>
              <TextArea2
                value={isEditing ? value : notesHistoryChanged}
                onChange={(e) => setValue(e.target.value)}
                disabled={!isEditing}
              />
            </ContentTextArea>
            {isEditing && (
              <>
                <DialogCancel
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsEditing(false)
                    setValue('')
                    setIsRequireAttention(isRequireAttentionHistory)
                  }}
                >
                  Cancel
                </DialogCancel>
                <DialogConfirm type="submit" onClick={() => {
                  handleSubmit()
                }}>Confirm</DialogConfirm>
              </>
            )}

          </Form>
        </Formik>
      </DialogBody>
    </Dialog>
  );
}